import React from 'react';
import { Send } from 'lucide-react';
import ChannelConfigsManagement from './ChannelConfigsManagement';

const TelegramConfigsManagement = () => (
  <ChannelConfigsManagement
    icon={Send}
    title="Telegram"
    subtitle="Manage Telegram channel configurations for each store"
    apiPrefix="/admin/telegram-config"
    tokenLabel="Bot Token"
    tokenFieldName="botToken"
    recipientLabel="Chat ID"
    recipientFieldName="chatId"
  />
);

export default TelegramConfigsManagement;
